export const DynamicImportReloadKey = 'dynamic-import-reload-attempted';
export const DynamicImportReloadTimeoutMs = 30_000;

/** A lazy chunk that failed to download. Chrome and Firefox say "... dynamically imported module",
 *  Safari "Importing a module script failed". */
export function isDynamicImportError(error: unknown): error is Error {
  if (!(error instanceof Error)) {
    return false;
  }
  const msg = error.message.toLowerCase();
  return msg.includes('dynamically imported module') || msg.includes('importing a module script failed');
}

/** The chunk named in the error; Safari's message names none. */
export function failedChunkUrl(error: Error): string | undefined {
  return /\S+\.js\b/.exec(error.message)?.[0];
}

export function wasReloadRecentlyAttempted(): boolean {
  const lastAttempt = sessionStorage.getItem(DynamicImportReloadKey);
  return !!lastAttempt && Date.now() - Number(lastAttempt) < DynamicImportReloadTimeoutMs;
}

let staleChunkReloading = false;

/** True once this page has started the stale-chunk reload and is on its way out. */
export function isStaleChunkReloading(): boolean {
  return staleChunkReloading;
}

export function setStaleChunkReloading(reloading: boolean) {
  staleChunkReloading = reloading;
}
